import { Box, Stack, Typography } from "@mui/material";
import { ThemeWrapper } from "@verity/components";
import { CoreButton } from "@verity/components/core";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "../../../../../../i18n";
import styles from "./SuccessPage.module.css";
import { BellIcon, ChainIcon, CircleCheckIcon, InboxIcon } from "./assets";
import DataBar from "./components/DataBar";
import Step from "./components/Step";

const COLORS = [
	{
		textColor: "#155DFC",
		borderColor: "#BEDBFF",
		backgroundColor: "#EFF6FF",
		iconBackgroundColor: "#DBEAFE",
	},
	{
		textColor: "#7F22FE",
		borderColor: "#DDD6FF",
		backgroundColor: "#F5F3FF",
		iconBackgroundColor: "#EDE9FE",
	},
	{
		textColor: "#C926B3",
		borderColor: "#FCD8F7",
		backgroundColor: "#FCE7F9",
		iconBackgroundColor: "#FCE7F9",
	},
];

type LocationState = {
	candidateName: string;
	positionName: string;
	date: Date;
};

export default function SuccessPage() {
	const navigate = useNavigate();

	const location = useLocation();
	const { candidateName, positionName, date } = location.state as LocationState;

	return (
		<ThemeWrapper scoped={false}>
			<Stack justifyContent="space-between" flexGrow={1} overflow="auto">
				<div className={styles.pageWrapper}>
					<Stack width="100%" gap="16px" alignItems="center">
						<div className={styles.greenCircle}>
							<CircleCheckIcon />
						</div>

						<Stack gap="4px" alignItems="center">
							<Typography className={styles.title}>
								{i18n.t("candidate.scheduleInterview.successPage.title")}
							</Typography>
							<Typography className={styles.description}>
								{i18n.t("candidate.scheduleInterview.successPage.description")}
							</Typography>
						</Stack>

						<DataBar candidateName={candidateName} positionName={positionName} startTime={date} />
					</Stack>
					<Box marginY="25px">
						<Typography className={styles.blockText}>
							{i18n.t("candidate.scheduleInterview.successPage.nextSteps.title")}
						</Typography>
					</Box>
					<Stack width="60%">
						<Step
							icon={<InboxIcon />}
							number={1}
							color={COLORS[0]}
							title={i18n.t("candidate.scheduleInterview.successPage.nextSteps.steps.step1.title")}
							description={i18n.t("candidate.scheduleInterview.successPage.nextSteps.steps.step1.description")}
						/>
						<Step
							icon={<ChainIcon />}
							number={2}
							color={COLORS[1]}
							title={i18n.t("candidate.scheduleInterview.successPage.nextSteps.steps.step2.title")}
							description={i18n.t("candidate.scheduleInterview.successPage.nextSteps.steps.step2.description")}
						/>
						<Step
							isLastStep
							icon={<BellIcon />}
							number={3}
							color={COLORS[2]}
							title={i18n.t("candidate.scheduleInterview.successPage.nextSteps.steps.step3.title")}
							description={i18n.t("candidate.scheduleInterview.successPage.nextSteps.steps.step3.description")}
						/>
					</Stack>
				</div>
				<div className={styles.actionBar}>
					<CoreButton color="secondary" onClick={() => navigate("/interviews/schedule")}>
						{i18n.t("candidate.scheduleInterview.successPage.buttons.schedule")}
					</CoreButton>
					<CoreButton onClick={() => navigate("/interviews")}>
						{i18n.t("candidate.scheduleInterview.successPage.buttons.dashboard")}
					</CoreButton>
				</div>
			</Stack>
		</ThemeWrapper>
	);
}
